import RSAA from 'redux-api-middleware/lib/RSAA';
import endpoints from '../../utils/endpoints';

export const FETCH_STATUS_CODE_MAPPING = 'FETCH_STATUS_CODE_MAPPING';
export const FETCH_STATUS_CODE_MAPPING_SUCCESS = 'FETCH_STATUS_CODE_MAPPING_SUCCESS';
export const FETCH_STATUS_CODE_MAPPING_FAILURE = 'FETCH_STATUS_CODE_MAPPING_FAILURE';

export const fetchStatusCodeMapping = () => {
	const action = {
		[RSAA]: {
			endpoint: endpoints.statusMapping.uri,
			method: 'GET',
			types: [
				{
					type: FETCH_STATUS_CODE_MAPPING,
					meta: {
						noAuthApiHeaders: true,
					},
				},
				FETCH_STATUS_CODE_MAPPING_SUCCESS,
				FETCH_STATUS_CODE_MAPPING_FAILURE,
			],
		},
	};

	return action;
};
